import React from 'react';
import { IconButton, SvgIcon, SxProps, Theme } from '@mui/material';
import { IconName } from '../../../utils/getMuiIcon';
import getMuiIcon from '../../../utils/getMuiIcon';
import { borderRadius, palette, spaces } from '../../../assets/styles/themes/tokens';

interface NavIconProps {
  icon: IconName;
  onClick: () => void;
  navIconSx?: SxProps<Theme>;
}

const listItemIconStyles = {
  color: palette.text.secondary,
  padding: spaces.xs,
  '&:hover': {
    borderRadius: borderRadius.xs,
    backgroundColor: palette.primary.selected,
    '& svg': {
      color: palette.primary.main,
    },
  },
  '&:focus': {
    borderRadius: borderRadius.xs,
    backgroundColor: 'transparent',
    outline: 'none',
  },
  '&:focus:hover': {
    backgroundColor: palette.primary.selected,
  },
  '&:active': {
    backgroundColor: palette.common.white,
  }
};

const NavIcon: React.FC<NavIconProps> = ({ icon, onClick, navIconSx }) => {
  return (
    <IconButton sx={{ ...listItemIconStyles, ...navIconSx }} onClick={onClick}>
      <SvgIcon component={getMuiIcon(icon)} />
    </IconButton>
  );
};

export default NavIcon;
